// extracted by mini-css-extract-plugin
export default {"root":"jUCqG7","bg":"b7qtGU","shadow":"zZWmY2","leftBottom":"tGl2cK","rightBottom":"FyT2Le","centerBottom":"gtrNSh"};